import Vue from "vue"
import { library } from "@fortawesome/fontawesome-svg-core"
import {
  faTrashAlt,
  faEdit,
  faTimes,
  faPen,
  faSignOutAlt,
  faCog,
  faKey,
  faBars,
  faUserCog,
  faUserPlus,
  faGlobe,
  faBuilding,
  faInfo,
  faMinus,
  faPlus,
  faPaperPlane,
  faEnvelopeOpen,
  faFileCsv,
  faEllipsisV,
  faFileExport
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"

library.add(faTrashAlt)
library.add(faEdit)
library.add(faPen)
library.add(faTimes)
library.add(faSignOutAlt)
library.add(faCog)
library.add(faKey)
library.add(faBars)
library.add(faUserCog)
library.add(faUserPlus)
library.add(faGlobe)
library.add(faBuilding)
library.add(faInfo)
library.add(faMinus)
library.add(faPlus)
library.add(faPaperPlane)
library.add(faEnvelopeOpen)
library.add(faFileCsv)
library.add(faEllipsisV)
library.add(faFileExport)

Vue.component("font-awesome-icon", FontAwesomeIcon)
